import {Action} from 'redux'
import {LoanEligibilityLogModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface ILoanEligibilityLogState {
  data?: {
    loanEligibilityLog?: LoanEligibilityLogModel[]
    meta?: {[key: string]: number}
  }
  loading?: boolean
}

const initialState: ILoanEligibilityLogState = {
  data: {loanEligibilityLog: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: ILoanEligibilityLogState = initialState,
  action: ActionWithPayload<ILoanEligibilityLogState['data']>
) => {
  switch (action.type) {
    case actionTypes.GET_LOAN_ELIGIBILITY_LOG_START:
      return {...state, loading: true}
    case actionTypes.GET_LOAN_ELIGIBILITY_LOG_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_LOAN_ELIGIBILITY_LOG_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
